'use strict';exports.__esModule = true;var styleTab = exports.styleTab = {
  padding: '10px 10px',
  display: 'inline-flex',
  cursor: 'pointer',
  color: '#231F20',
  textAlign: 'center',
  fontSize: '18px',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: '600' };


var styleActiveTab = exports.styleActiveTab = Object.assign({},
styleTab, {
  background: 'inherit',
  borderBottom: 'solid #04AAEB 2px' });


var errorKeys = exports.errorKeys = {
  INCORRECT_CODE: {
    title: 'incorrect_code' },

  INVALID_DISCOUNT_CODE: {
    title: 'invalid_discount_code' },

  EMAIL_ALREADY_EXISTS: {
    title: 'email_already_exists',
    subTitle: 'sub_title_email_already_exists' },

  PHONE_ALREADY_EXISTS: {
    title: 'phone_already_exists',
    subTitle: 'sub_title_phone_already_exists' },

  SOMETHING_WENT_WRONG: {
    title: 'something_went_wrong' },

  CANNOT_SEND_SMS_AT_THIS_MOMENT: {
    title: 'cannot_send_sms_at_this_moment' },

  PHONE_NOT_VERIFIED: {
    title: 'phone_not_verified',
    subTitle: 'sub_title_phone_not_verified' },

  WRONG_PASSWORD: {
    title: 'wrong_password',
    subTitle: 'sub_title_wrong_password' },

  EMAIL_NOT_EXISTS: {
    title: 'email_not_exists',
    subTitle: 'sub_title_email_not_exists' },

  EXCEEDED_LIMIT_PER_MINUTE: {
    title: 'exceeded_limit_per_minute',
    subTitle: 'sub_title_exceeded_limit_per_minute' },

  EXCEEDED_LIMIT_PER_DAY: {
    title: 'exceeded_limit_per_day',
    subTitle: 'sub_title_exceeded_limit_per_day' } };



var getErrorKeyCase = exports.getErrorKeyCase = function getErrorKeyCase(key) {return errorKeys[key] || errorKeys.SOMETHING_WENT_WRONG;};


//////////////////
// WEBPACK FOOTER
// ./src/pages/UserAuthenticationPage/constants.js
// module id = 1248
// module chunks = 0